'use client';

import { useState, useEffect } from 'react';
import Icon, { IconName } from '@/components/ui/Icon';
import { cities } from '@/constants/locations';

export function LocalTimeDisplay({ city }: { city: string }) {
  const timezone = cities.find((c) => c.value === city)?.timezone;
  const [time, setTime] = useState<Date | null>(null);

  useEffect(() => {
    setTime(new Date());
    const timer = setInterval(() => setTime(new Date()), 60000); // Update every minute
    return () => clearInterval(timer);
  }, []);

  if (!city || !time) return null;

  return (
    <span className='flex items-center justify-center space-x-1'>
      <Icon variant={IconName.Globe} width={12} height={12} />
      <span>
        {time.toLocaleTimeString([], {
          timeZone: timezone,
          hour: '2-digit',
          minute: '2-digit',
        })}
      </span>
    </span>
  );
}
